import styled from 'vue-styled-components'

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

// 垂直居中
const FlexCenter = styled(Flex)`
  flex-direction: column;
  gap: 10px;
  grid-gap: 10px;
`

const FlexBetween = styled(Flex)`
  justify-content: space-between;
`

export { Flex, FlexCenter, FlexBetween }
